import { Subscription, SubscriptionStatus } from '@/shared/types/Billing';

import { isSubscriptionExpired } from './isSubscriptionExpired';

const ACTIVE_SUBSCRIPTION_STATUSES = new Set([
  SubscriptionStatus.Active,
  SubscriptionStatus.Incomplete,
  SubscriptionStatus.IncompleteExpired,
  SubscriptionStatus.Trialing,
]);
export const isSubscriptionActive = (subscription: Subscription) => {
  return (
    ACTIVE_SUBSCRIPTION_STATUSES.has(subscription.status) &&
    !isSubscriptionExpired(subscription.current_period_end) &&
    !subscription?.payments_collection_paused
  );
};
